const ProfileIcon2 = () => (
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 8C9.20938 8 11 6.20906 11 4C11 1.79094 9.20938 0 7 0C4.79063 0 3 1.79094 3 4C3 6.20906 4.79063 8 7 8ZM7 1C8.65438 1 10 2.34562 10 4C10 5.65406 8.65438 7 7 7C5.34562 7 4 5.65312 4 4C4 2.34562 5.34688 1 7 1ZM8.58438 9.5H5.41563C2.42531 9.5 0 11.925 0 14.9156C0 15.5138 0.485 15.9991 1.08312 15.9991H12.9175C13.5156 16 14 15.5156 14 14.9156C14 11.925 11.575 9.5 8.58438 9.5ZM12.9156 15H1.08312C1.0375 15 1 14.9625 1 14.9156C1 12.4812 2.98125 10.5 5.41563 10.5H8.58125C11.0188 10.5 13 12.4812 13 14.9156C13 14.9625 12.9625 15 12.9156 15Z"
      fill="#374151"
    />
  </svg>
);
export default ProfileIcon2;
